import type { InputHTMLAttributes, Ref, ReactNode } from 'react';

export enum INPUT_CONST {
  TEST_ID = 'input-base',
}

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
  ghost?: boolean;
  ref?: Ref<HTMLInputElement & HTMLTextAreaElement>;
  renderPrefix?: ReactNode;
  renderSuffix?: ReactNode;
  success?: boolean;
  validationHint?: string;
};
